import React from 'react'

import { Col, Grid } from '../../../kiti/components/structure/Grid'
import { useTinyColor } from '../../../kiti/components/theme/_hooks/colors'
import ImagePlugin from '../_plugins/ImagePlugin'
import InterpolationPlugin from '../_plugins/InterpolationPlugin'
import Line from '../../../kiti/components/helpers/Line'
import LinkPlugin from '../_plugins/LinkPlugin'
import ListPlugin from '../_plugins/ListPlugin'
import MarkerPlugin from '../_plugins/MarkerPlugin'

const ControlBar = ({ interpolations }) => {
  const bgColor = useTinyColor('light1').lighten(2).toHexString()

  return (
    <>
      <Grid padding={0.4} gap={0.6} gColor={bgColor} align="center">
        <MarkerPlugin.ToggleIcon icon="RiBold" name="bold" />
        <MarkerPlugin.ToggleIcon icon="RiItalic" name="italic" />
        <Col>
          <Line vertical height={0.6} color="light2" />
        </Col>
        <ListPlugin.ToggleIcon name="list" />
        <ListPlugin.ToggleIcon name="numered_list" />
        <Col>
          <Line vertical height={0.6} color="light2" />
        </Col>
        <LinkPlugin.ToggleIcon />
        <ImagePlugin.Icon />
        <Col flex={1} />

        <InterpolationPlugin.Dropdown options={interpolations} />
      </Grid>

      <LinkPlugin.Menu />
      <Line />
    </>
  )
}

export default ControlBar
